let _ = require("underscore");
import POS from "../POS.js";
let NotificationModel = require("../model/NotificationModel.js");

let main = function () {
    //var status = new Backbone.Model({status:"Create"});
    var notificationService = {
        notificationCollection: null,
        _initialize: function () {
            this.notificationCollection = POS.getNotifications();
        },
        getNotifications: function () {
            return this.notificationCollection;
        },
        saveNotification: function (notification) {
            console.log("add notification--" + notification);
            if (notification && !POS.getNotifications().get(notification.id)) {
                var notice = new NotificationModel(notification);
                POS.getNotifications().add(notice);
            }
        }
    };
    notificationService.initialize = _.once(notificationService._initialize);
    return notificationService;
};

let exportedValue = main();
export default exportedValue;


// WEBPACK FOOTER //
// ./src/service/NotificationService.js